import { useTranslation } from 'react-i18next';
import React from 'react';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { Skeleton } from '@mui/material';

const Title = ({ isPreviousEvent, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Skeleton
        style={{ borderRadius: '50px' }}
        variant="rectangular"
        width={400}
        height={40}
      />
    );
  }

  return (
    <Typography
      className="leaderboard-title"
      color={COLOR.darkGray}
      variant="heading-48-bold"
    >
      {`🏆 ${isPreviousEvent ? t('finalLeaderboard') : t('leaderboard')}`}
    </Typography>
  );
};

export default Title;
